import type { SelectChangeEvent } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import type { CSSProperties } from 'react';

type SelectInputColumnProps = {
  menuItems: string[] | number[];
  isMultiple?: boolean;
  handleChange: (event: SelectChangeEvent<string[]>) => void;
  value?: string[];
  maxWidth?: string;
  width?: string;
  customSelectStyle?: CSSProperties;
  variant?: 'standard' | 'outlined';
};

export const SelectInputColumn = ({
  maxWidth = '160px',
  width = '100%',
  menuItems,
  handleChange,
  value = [],
  isMultiple = false,
  customSelectStyle,
  variant = 'standard',
}: SelectInputColumnProps) => {
  return (
    <Grid item flexGrow={1} width={width} maxWidth={maxWidth}>
      <FormControl variant={variant} size="small" fullWidth>
        <Select<string[]>
          id="drop-down-select"
          data-testid="drop-down-select"
          sx={{ ...customSelectStyle }}
          color="secondary"
          label={variant === 'standard' ? value.join(', ') : undefined}
          labelId={variant === 'standard' ? `${value}-label` : undefined}
          MenuProps={{ disableScrollLock: true }}
          multiple={isMultiple}
          onChange={handleChange}
          renderValue={(selected) => (Array.isArray(selected) ? selected.join(', ') : '')}
          value={value}
        >
          {menuItems.map((item) => (
            <MenuItem key={item} value={item}>
              {item}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>
  );
};
